import React from 'react';
import clsx from 'clsx';
import 'react-quill/dist/quill.snow.css';
import './index.scss';

interface DisplayHtmlContentProps {
  html: string | TrustedHTML;
  className?: string;
  style?: React.CSSProperties;
  bordered?: boolean;
}

function DisplayHtmlContent({
  html, className, bordered, style,
}: DisplayHtmlContentProps) {
  return (
    <div className="ql-snow">
      <div
        className={clsx('ql-editor quill-display', { bordered }, className)}
        dangerouslySetInnerHTML={{ __html: html }}
        style={style}
      />
    </div>
  );
}

export default DisplayHtmlContent;
